export default __webpack_public_path__ + "static/media/PublicCourseType.84ca0ff5.svg";